import BillingCreate from "./BillingCreate";
import BillingList from "./BillingList";
import ReceiptIcon from "@mui/icons-material/Receipt";

const billing = {
  list: BillingList,
  create: BillingCreate,
  icon: ReceiptIcon,
};

export default billing;
